import React, { useContext, useEffect, useState } from 'react';
import { TransitionContext } from '../Context/TransitionContext';

import './Terms.css';

import { useScreenTransition } from '../Hooks/useScreenTransition';
import SignInForm from './SignIn/SignInForm';
import CreateAccount from './CreateAccount/CreateAccount';


import Navbar from './HomePage/header';

import Footer from './HomePage/footer';
import SupportSection from './HomePage/SupportSection';
import axios from 'axios';
import { Lock } from 'react-feather';

import { FormTextInput } from '../Components/FormTextInput';
import { NotificationContext } from '../Context/NotificationContext';
import { useEnterKey } from '../Hooks/useEnterKey';
import { getFullHttpUrl } from '../firebase.config';
import { EAST1, EAST4 } from '../utility/enums';
import NewButton from '../NewComponents/NewButton';

const OrderLookup = ({ windowSize }) => {

  const { transitionTo } = useScreenTransition();

  const { setColor } = useContext(TransitionContext);

  const { showNotification } = useContext(NotificationContext);

  useEffect(() => {
    setColor(true);
  }, [setColor]);

  const [email, setEmail] = useState('');
  const [orderNumber, setOrderNumber] = useState('');

  const [submitButton, setSubmitButton] = useState('Find');
  const [isModalOpen, setIsModalOpen]=useState(false);
  const [isCreateAccountOpen, setIsCreateAccountOpen]=useState(false);


  const handleLoginOpen=(newState)=>{
    setIsModalOpen(newState);
  }

  const handleCreateAccountOpen=(newState)=>{
    setIsCreateAccountOpen(newState);
  }

  const handleLookup = async () => {
    setSubmitButton('Finding...');

    axios({
      method:'post',
      url: getFullHttpUrl("orderLookup", EAST4),
      data: {
        email: email.toLowerCase(),
        number: orderNumber
      }
    })
      .then((response) => {
        transitionTo(response.data.link);
      })
      .catch((error) => {
        setSubmitButton('Find');

        if (error.response.status === 404) {
          showNotification('Error', "There is no order with that information. Please, try again. If you can't find your order, contact Support for help.", 'error');
        } else {
          showNotification('Error', 'An error ocurred finding the order. Try again. If it persists, please contact Support.', 'error');
        }
      });

  }

  const triggerLookup = () => {
    if (!(email === "" || orderNumber === "")) {
      handleLookup();
    }
  }

  useEnterKey(() => triggerLookup());

  return (
    <div className='bg-[#EFF3F5] w-full flex flex-col items-center cursor-default'>
    <SignInForm open={isModalOpen} isLoginFormOpen={handleLoginOpen} isCreateAccountOpen={handleCreateAccountOpen}/>
    <CreateAccount open={isCreateAccountOpen} isCreateAccountOpen={handleCreateAccountOpen} isLoginFormOpen={handleLoginOpen}/>


     {/* banner */}
     <div className='w-full md:p-4 p-2'>

      <div className='w-full bg-[#12ABBF] rounded-4xl max-md:rounded-xl max-md:pb-4'>
          {/* navbar */}
        <div className=' pt-[30px] pb-[27px] mx-4'>
            <Navbar windowSize={windowSize} isLoginFormOpen={handleLoginOpen}/>
        </div>
        <div className='bannerContainer px-2'>
            <h1 className='bannerText text-center'>Order Lookup</h1>
        </div>
        <div className='flex flex-col gap-4 w-full items-center pb-[107px] max-md:pb-[30px] px-2'>
          <p className='text-[#fff] text-base text-center xl:w-[50%] md:w-1/2 w-full'>Check the status of your order, download files, and request revisions. Your order number can be found in your order confirmation email.</p>
          <p className='w-full flex items-center justify-center gap-2 text-[#fff] text-base text-center xl:w-[50%] md:w-1/2 w-full'>
          <Lock color='#fff' size={20} />
            <p className="text-[#fff] text-center">Have an account? <span className="border-b border-[#fff] cursor-pointer" onClick={(e) => handleLoginOpen(true)}>Sign in</span>.</p>
          </p>
        </div>
      </div>


      <div className=" bg-white rounded-4xl overflow-hidden shadow-sm py-12 my-4 max-md:rounded-xl">
        <div className="px-8 flex flex-col gap-4 justify-center items-center max-w-[1440px] mx-auto w-full">
        <h2 className='font-secondary font-medium md:text-5xl text-4xl text-tertiary uppercase text-left'>Find Your Order</h2>
        <p className="w-full mx-auto text-center text-xl">
        Enter your email and order number to find your order.
        </p>

        <div className="px-8 flex flex-col gap-4 justify-center items-center gap-[5px] flex-1 w-full max-w-[600px]">
          <FormTextInput placeholder="Email*" value={email} onChange={setEmail} color='#666' />
          <FormTextInput placeholder="Order Number*" value={orderNumber} onChange={setOrderNumber} color='#666' />
        </div>
        <NewButton text={submitButton} disabled={email === "" || orderNumber === ""} onClick={handleLookup} />
        </div>
      </div>
      

      <SupportSection windowSize={windowSize} />

     </div>

    <div className=' w-full pb-10 bg-[#12ABBF]'>
          <Footer windowSize={windowSize} light={true}  />
      </div>  

  </div>
  );
}

export default OrderLookup;